import { withinRange } from './utils.js';

export function addParallax(element) {

  let position = element.getAttribute('data-movement')
  const movement = (position) ? position : 80
  const contentWrapper = document.querySelector('.content-wrapper')

  const positionModifier = (e) => {

    let ratio = withinRange((contentWrapper.scrollTop - element.getBoundingClientRect().top) / (contentWrapper.clientHeight * 0.7), 0, 1);

    let y = (movement*ratio)

    element.style.transform =  `translateY(${y}px)`

  }

  contentWrapper.addEventListener('scroll', positionModifier)

}



// WEBPACK FOOTER //
// ./src/parallax.js